import type { Router } from 'vue-router';
import { localStg } from '@/utils/storage';

/**
 * OA 单点登录 Guard
 *
 * 处理其他系统跳转时 URL 携带的 ssoToken 参数：
 *
 * 1. 将 ssoToken 写入本地存储
 * 2. 回填来源系统携带的组织/部门信息（登出会清空这些键，不回填则顶部「组织：xxx」为空）
 * 3. 去除 URL 中的 ssoToken 及组织参数（replace 模式，不留历史记录）
 *
 * 必须在 createRouteGuard（initRoute）之前注册， 否则 initRoute 会因 token 尚未写入而将用户重定向到登录页。
 *
 * 注意：此处不能实例化 store（守卫在组件外运行，auth store 依赖 useRoute 注入上下文）， 直接按组织弹窗确认时的口径写 localStorage，挂载后 orgStore.initOrgInfo() 会读取这些键。
 *
 * @param router - Router instance
 */
export function createSsoGuard(router: Router) {
  router.beforeEach((to, _from, next) => {
    const { ssoToken, orgId, orgName, orgCode, deptId, deptName, deptCode, bestSignAccount, unifiedCode, ...restQuery } = to.query;

    if (typeof ssoToken === 'string' && ssoToken) {
      localStg.set('token', ssoToken);

      if (typeof orgCode === 'string' && orgCode) {
        localStg.set('selectedOrgId', typeof orgId === 'string' ? orgId : '');
        localStg.set('selectedOrgName', typeof orgName === 'string' ? orgName : '');
        localStg.set('selectedOrgCode', orgCode);
      }

      if (typeof deptCode === 'string' && deptCode) {
        localStg.set('selectedDeptId', typeof deptId === 'string' ? deptId : '');
        localStg.set('selectedDeptName', typeof deptName === 'string' ? deptName : '');
        localStg.set('selectedDeptCode', deptCode);
      }

      if (typeof bestSignAccount === 'string' && bestSignAccount) {
        localStg.set('orgbestSignAccount', bestSignAccount);
      }

      if (typeof unifiedCode === 'string' && unifiedCode) {
        localStg.set('orgUnifiedCode', unifiedCode);
      }

      next({ path: to.path, query: restQuery, replace: true });
      return;
    }

    next();
  });
}
